<template>
  <div v-loading="loading" class="order-details">
    <div class="box">
      <div class="title">预订信息</div>
      <el-table :data="orderInfoData.records" tooltip-effect="light" max-height="400px">
        <el-table-column width="30">
          <template slot-scope="scope">
            <el-radio v-model="chooseId" :disabled="!scope.row || scope.row.roomStatus != 2" :label="scope.row.roomOrderId" @change="chooseInfo(scope.row)"></el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="customerName" width="100" label="顾客姓名" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.customerName || '新增顾客' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="customerPhone" width="120" label="手机号码" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.customerPhone || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="roomName" width="120" :label="'预订'+Lib.returnRoomOrBed()+'名称'" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ getRoomType == 1 ? scope.row.roomName : (scope.row.roomName+'/'+scope.row.bedNumber) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="beginTime" label="预使用时间" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.beginTime || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="endTime" label="预离时间" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.endTime || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="dateTime" label="预计使用时长" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ Lib.calculationTime(scope.row.dateTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="roomStatus" width="90" label="预订状态" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span :style="scope.row.roomStatus == 2 ? 'color: #E6A23C;' : 'color: #333;'">{{ scope.row.roomStatus == 2 ? '已预订' : '预订已取消' }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="float: right;">
      <el-button :disabled="!chooseId" @click="chooseId ? onCancelCheckIn() : ''">取消预订</el-button>
      <el-button :disabled="!chooseId" type="primary" @click="chooseId ? undateRoomerDetail() : ''">修改预订</el-button>
      <el-button :disabled="!chooseId" type="primary" @click="chooseId ? isConfirmCheckIn() : ''">使用{{ Lib.returnRoomOrBed() }}</el-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    orderInfoData: {
      type: Object,
      default: Object
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tooltipStatus: false, // 文字过长的显示和隐藏
      getRoomType: window.sessionStorage.tidyStatus, // 设置的房态  1房间  2床位  3台位(5.10)
      menusList: [],
      roomList: {},
      chooseId: ''
    };
  },
  watch: {
    loading(val) {
      if (val == false) {
        this.chooseId = '';
      }
    },
  },
  activated() {
    this.getRoomType = window.sessionStorage.tidyStatus;// 设置的房态  1房间  2床位  3台位
    this.$emit('tansferDialog', false);
    this.menusList = JSON.parse(sessionStorage.getItem('menusList'));
  },
  methods: {
    chooseInfo(val) {
      this.chooseId = val.roomOrderId;
      this.roomList = val;
    },
    // 取消预订
    onCancelCheckIn() {
      this.$emit('fatherMethod', { status: 1, obj: this.roomList });
    },
    // 修改
    undateRoomerDetail() {
      this.$emit('fatherMethod', { status: 2, obj: this.roomList });
    },
    // 使用
    isConfirmCheckIn() {
      this.$emit('fatherMethod', { status: 3, obj: this.roomList });
    },
  }
};
</script>
<style lang="less" scoped>
.el-table td,
.el-table th {
  padding: 7px 0;
}
.memberInfo::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: #f5f5f5;
}
.memberInfo::-webkit-scrollbar-track-piece {
  background-color: #fff;
}
.memberInfo::-webkit-scrollbar-track {
  box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  -webkit-box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}
.memberInfo::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  -webkit-box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  background-color: #eee;
}
.memberInfo {
  height: 80px;
  padding: 0 0 10px 0;
  width: 940px;
  overflow-x: visible;
  overflow-y: hidden;
  .srcoll {
    padding: 10px 30px;
    background-color: #f5f7fa;
    width: max-content;
    min-width: 880px;
    height: 60px;
    overflow: hidden;
    .payStatus {
      float: right;
      margin-top: -24px;
      margin-right: -25px;
      img {
        width: 60px;
        height: 60px;
        display: block;
        float: right;
        padding-right: 10px;
      }
      p {
        height: 30px;
        line-height: 30px;
        padding-right: 10px;
        font-size: 14px;
        color: #fd5c8c;
        cursor: pointer;
        float: right;
        clear: both;
      }
    }
    .i_one {
      float: left;
      width: 60px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      border-radius: 50%;
      background-color: #fff;
      margin-right: 20px;
      i {
        color: #999;
        font-size: 28px;
      }
      img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        float: left;
      }
    }
    .li {
      float: left;
      padding: 8px 30px 8px 0;
      h5 {
        img {
          width: 20px;
          margin: 12px 9px 12px 0;
          float: left;
        }
        font-size: 14px;
        color: #333;
        height: 44px;
        line-height: 44px;
        max-width: 240px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      p {
        font-size: 14px;
        color: #333;
        height: 22px;
        line-height: 22px;
        span {
          float: right;
          font-size: 12px;
          background-color: #ffe9ee;
          color: #fd5c8c;
          height: 19px;
          line-height: 19px;
          border-radius: 8px;
          margin-left: 5px;
          padding: 0 5px 0 23px;
          i {
            position: relative;
            display: block;
            float: left;
            font-size: 12px;
            margin: -2px 0 0 -25px;
            background-color: #ffe9ee;
            text-align: center;
            width: 23px;
            height: 23px;
            line-height: 23px;
            border-radius: 50%;
          }
        }
      }
    }
  }
}
.orderRemark {
  width: 940px;
  border-bottom: 1px solid #e6ebf5;
  display: flex;
  h3 {
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: column;
    width: 89px;
    text-align: center;
    font-size: 14px;
    background-color: #f5f7fa;
    color: #333;
    float: left;
    border-right: 1px solid #e6ebf5;
  }
  h5 {
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    width: 139px;
    padding-left: 5px;
    font-size: 14px;
    color: #333;
    float: left;
  }

  h6 {
    flex: 1;
    padding: 10px 0;
    line-height: 26px;
    padding-left: 5px;
    font-size: 14px;
    color: #333;
    float: left;
    word-wrap: break-word;
  }
}
.orderInfo {
  width: 940px;
  border-top: 1px solid #e6ebf5;
  display: table;
  .remarks{
    width: calc(100% - 100px)!important;
  }
  h2 {
    width: 140px;
    height: 32px;
    line-height: 16px;
    padding: 7px 0 7px 5px;
    font-size: 13px;
    color: #333;
    float: left;
    border-bottom: 1px solid #e6ebf5;
  }
  h3 {
    width: 89px;
    height: 46px;
    line-height: 46px;
    text-align: center;
    font-size: 14px;
    background-color: #f5f7fa;
    color: #333;
    float: left;
    border-right: 1px solid #e6ebf5;
    border-bottom: 1px solid #e6ebf5;
  }
  h4 {
    width: 139px;
    height: 46px;
    line-height: 46px;
    padding-left: 5px;
    font-size: 14px;
    color: #333;
    float: left;
    border-bottom: 1px solid #e6ebf5;
  }
  h5 {
    width: 139px;
    height: 46px;
    line-height: 46px;
    padding-left: 5px;
    font-size: 14px;
    color: #333;
    float: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-bottom: 1px solid #e6ebf5;
  }
  h6 {
    width: 375px;
    height: 46px;
    line-height: 46px;
    padding-left: 5px;
    font-size: 14px;
    color: #333;
    float: left;
    border-bottom: 1px solid #e6ebf5;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.order-details .border p label {
  color: #333 !important;
}
.autograph {
  width: 65px;
  height: 22px;
  border-radius: 5px;
  float: right;
  font-size: 12px;
  text-align: center;
  line-height: 22px;
  float: left;
  margin-right: 10px;
}
.autograph_D {
  border: 1px solid #e5e5e5;
  background-color: #f7f8fa;
  color: #999;
}
.autograph_G {
  background-color: #f0f9eb;
  border: 1px solid #e1f3d8;
  color: #67c23a;
}
.order-details{
  width: 100%;
}
.collapseInfo {
  float: left;
  padding-right: 20px;
  width: 630px;
  samp {
    color: #999;
  }
  span {
    color: #333;
  }
  span:nth-child(1) {
    float: left;
    width: 80px;
  }
  span:nth-child(2) {
    float: left;
    width: 220px;
  }
  span:nth-child(3) {
    float: left;
    width: 200px;
  }
  span:nth-child(4) {
    float: left;
    width: 130px;
  }
}
.collapseBtn {
  text-align: right;
  width: 206px;
}
</style>

<style>
.el-dialog__body {
  overflow-x: hidden !important;
  overflow-y: visible;
}
.order-details .el-loading-spinner {
  background-position-y: 50%;
  top: 0;
  padding-top: 0;
}
.order-details .el-collapse {
  margin-bottom: 20px;
}
.el-collapse-item__content {
  padding-bottom: 0;
}
</style>
